import styled from 'styled-components'
// theme
import { colors } from 'themes'

export const SsoLoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  min-height: 398px;
  width: 100%;
  text-align: center;

  > span {
    width: 100%;
    border-top: 1px solid lightgrey;
  }
`

export const SsoLoadingText = styled.p`
  margin: 0;
  color: ${colors.gray900};
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
`
